<div class="p-3 mb-4 dialog-title">Information !!</div>
<div class="p-2 m-2">
    <p style="font-size: 16px !important;">
        Please contact your administration.
        You have not necessary permissions to login as you 
        are not belonged to any group from your organization.
    </p>  
</div>
<div class="dialog-footer">
    <button class="btn" (click)="closeGrpPopUp()">Close</button>
</div>